import { Component, OnInit, ViewChild} from '@angular/core';
import { NgForm} from '@angular/forms';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UIRouter, Transition } from "@uirouter/angular";
import { DatepickerComponent } from '../datepicker/datepicker.component';
import { TimepickerComponent } from '../timepicker/timepicker.component';
 import { AuditTrailItemsComponent } from '../audit-trail-items/audit-trail-items.component';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';

import { AuditTrailService } from "../audit-trail-service/audit-trail.service"
import { CustomerService } from "../customer-service/customer.service"
import { ApiService } from "../api-service/api.service"

@Component({
  selector: 'app-audit-trail',
  templateUrl: './audit-trail.component.html',
  styleUrls: ['./audit-trail.component.less']
})
export class AuditTrailComponent implements OnInit {

  private className: string
  private auditTrailCustomerProfile: any
  private auditTrailType: string
  private auditTrailDownloadUrl: string

  constructor(private router: UIRouter, 
              private auditTrailService: AuditTrailService,
              private customerService: CustomerService,
              private apiService: ApiService) { }

  ngOnInit() {

      if(this.router.stateService.$current.name == 'app.customerAudit'){

        this.customerService.retrieveCustomer(this.router.globals.params.customerId);

        this.customerService.profile.subscribe((x)=>{
          
          this.auditTrailCustomerProfile = x

        })

        this.auditTrailType = 'Customer';
        this.auditTrailDownloadUrl = this.apiService.apiEndpoint+'/audit/'+this.router.globals.params.customerId+'/download?authorization='+this.apiService.token;

      }
      else
      {
        this.auditTrailType = 'Staff';
      }

      this.auditTrailService.auditTrailClassName.subscribe((x)=>{
         this.className = x   
      })

    }

    filterByDate(startDate,endDate){
    
      if(this.router.stateService.$current.name == 'app.customerAudit'){

      this.auditTrailService.retrieveCustomerAuditTrail(this.router.globals.params.customerId,startDate,endDate);

      // this.auditTrailService.auditTrailItems.subscribe((x)=>{
        
      //   this.auditTrailItems = x

      // })

    }

    }

}



// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/rooster/admin/src/app/audit-trail/audit-trail.component.ts